'use strict';

export default {
  list: []
};



// WEBPACK FOOTER //
// ./src/stores/modules/alerts-float/state.js